// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-a8ff88d4] .popper{transform:translate(110px,40px)!important}[data-v-a8ff88d4] .popper #arrow{transform:translate(220px)!important}.check_all-brand[data-v-a8ff88d4]{cursor:pointer}@media screen and (max-width:414px){.dosiin_filter-modal .filter-list-item-branch[data-v-a8ff88d4]{position:relative;z-index:1}[data-v-a8ff88d4] .popper{transform:translate(70px,40px)!important}}", ""]);
// Exports
module.exports = exports;
